// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../node_modules/less-loader/dist/cjs.js!../base/BellLink.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BqIeKd2EfzCBp6y0ByLp {
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/VipBellLink/VipBellLink.module.css"],"names":[],"mappings":"AAAA;AAEA","sourcesContent":[".vipBellLinkTheme {\n  composes: bellLinkTheme from '../base/BellLink.base.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vipBellLinkTheme": `BqIeKd2EfzCBp6y0ByLp ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bellLinkTheme"]}`
};
export default ___CSS_LOADER_EXPORT___;
